import React from 'react';
import { Box, Container, Header } from '@amzn/awsui-components-react';

/**
 * Common Balance Pools tab (MDA 1.1 Phase 2).
 *
 * CR1 scope: placeholder shell only. The CBP list, builder, and modals are
 * added in subsequent CRs. Data will be sourced through CommonBalancePoolService
 * (mock first, real backend later) so this component stays unchanged when the
 * backend lands.
 */
export default function CommonBalancePools() {
    return (
        <Container header={<Header variant="h2">Common Balance Pools</Header>}>
            <Box textAlign="center" padding="l" color="text-body-secondary">
                Common Balance Pools are coming soon.
            </Box>
        </Container>
    );
}
